import Swiper from 'swiper/bundle';

(function ($) {
    $('.section-media-slider').each(function () {
        const $this = $(this);
        const $slider = $this.find('.slider-media');
        const $next = $this.find('.swiper-button-next');
        const $prev = $this.find('.swiper-button-prev');
        const $scrollbar = $this.find('.swiper-scrollbar');

        new Swiper($slider[0], {
            slidesPerView: 'auto',
            spaceBetween: 24,
            navigation: {
                nextEl: $next[0],
                prevEl: $prev[0],
            },
            scrollbar: {
                el: $scrollbar[0],
                draggable: true,
            },
            breakpoints: {
                300: {
                    spaceBetween: 16,
                },
                767: {
                    spaceBetween: 20,
                },
                1439: {
                    spaceBetween: 24,
                },
            }
        });
    });
})(jQuery);